import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ allowedRoles, children }) => {
    const userRole = localStorage.getItem('userRole');

    if (!userRole) {
        return <Navigate to="/" replace />; // Redirect to login if no role
    }

    if (!allowedRoles.map(r => r.toLowerCase()).includes(userRole.toLowerCase())) {
        return <Navigate to="/NotFound" replace />;
    }

    return children;
};


export default ProtectedRoute;
